import { render, staticRenderFns } from "./IconCopyClipboard.vue?vue&type=template&id=3e0408d8&"
import script from "./IconCopyClipboard.vue?vue&type=script&lang=ts&"
export * from "./IconCopyClipboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports